import { message } from "antd";
import { FEEDBACK } from "../constants/url";
import { genericApiCall, getApiCall } from "../utils/servicesBaseUtil";
import { catchErrors } from "../utils/catchErrors";

export const submitFeedbackApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = FEEDBACK;

    // Convert feedback array of objects to a simple string
    let feedbackString = "";
    if (Array.isArray(data.feedback)) {
      feedbackString = data.feedback
        .map((obj) => {
          const key = Object.keys(obj)[0];
          const value = obj[key];
          return `${key}: ${value}`;
        })
        .join("\n"); // multiple feedbacks separated by new line
    }

    const payload = {
      ...data,
      feedback: feedbackString,
    };

    // console.log("payload to send", payload);

    genericApiCall({
      url: url,
      method: "POST",
      data: JSON.stringify(payload),
      ContentType: "application/json",
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          successCallback(responseJson);
        } else {
          message.error(responseJson?.message);
          failureCallback(responseJson?.data);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const getSubmitFeedbackApi = ({
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = FEEDBACK;

    getApiCall({ url: url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        } else {
          failureCallback(responseJson?.data);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};
